import * as Actions from '../../actions/supplies/type';

const initialState = {
  getSuppliesListLoading: false,
  suppliesList: [],
  error: '',
  loading: false,
  exportSupplies: '',

  importSuppliesError: '',
  importSuppliesData: '',
};
export const SuppliesReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Vehicle listing
    case Actions.GET_SUPPLIES_LISTING_REQUEST:
      return {
        ...state,
        getSuppliesListLoading: true,
      };
    case Actions.GET_SUPPLIES_LISTING_SUCCESS:
      return {
        ...state,
        getSuppliesListLoading: false,
        suppliesList: action?.payload?.supplies || [],
      };
    case Actions.GET_SUPPLIES_LISTING_FAIL:
      return {
        ...state,
        getSuppliesListLoading: false,
        error: action.payload,
      };

    // Export Supplies
    case Actions.EXPORT_SUPPLIES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Actions.EXPORT_SUPPLIES_SUCCESS:
      return {
        ...state,
        loading: false,
        exportSupplies: action?.payload || '',
      };
    case Actions.EXPORT_SUPPLIES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case Actions.CLEAR_EXPORT_SUPPLIES_STATE:
      return {
        ...state,
        error: '',
        loading: false,
        exportSupplies: '',
      };

    case Actions.CLEAR_IMPORT_SUPPLIES_STATE:
      return {
        ...state,
        importSuppliesError: '',
        importSuppliesData: '',
        loading: false,
      };
    default:
      return state;
  }
};
